
import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';
import { AppConstants } from '../../constants/AppConstants';
import * as agui from 'arm-gui/dist/controls';
import CategorieActions from './categorieProdottoActions';

import { Utils, DateFormatter, domain, UiUtils, i18n, isAuth, NumberFormatter } from 'arm-common';
import FamiglieProdottoActions from '../famigliaProdotto/famiglieProdottoActions'
import { ConfirmModalOkCancelV4, ConfirmModalSaveV4, ConfirmModalV4 } from '../shared/v4';

class CreateCategoria extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[CreateCategoria.jsx] ';
        this.state = {
            validation: new Map(),
            showConfirm: false,
        };
        this.annullaButton = this.annullaButton.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        // this.state = this.getInitalState();
        this.showConfirmPanel = this.showConfirmPanel.bind(this);
        this.salvaCategoria = this.salvaCategoria.bind(this);
        this.validateForm = this.validateForm.bind(this);

    }

    componentDidMount() {
        console.log(this.componentName + 'componentDidMount');

        this.props.getListFamiglie();

    }

    annullaButton() {
        console.log(this.componentName + 'annullaButton');
        this.props.history.goBack();

    }
    showConfirmPanel() {

        this.props.showPopUP(!this.props.showConfirm);
    }

    validateForm() {
        console.log(this.componentName + 'validateForm');
        let validation = new Map();
        let required = ['nome', "idFamigliaProdotto", 'descrizione'];
        for (let i = 0; i < required.length; i++) {
            if (this.props.categoriaProdotto[required[i]] === undefined || this.props.categoriaProdotto[required[i]] === '' || this.props.categoriaProdotto[required[i]] === null) {
                validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
            }
        }
        this.setState({ validation: validation });
        if (validation.size === 0) {
            // this.setState({ showConfirm: !this.state.showConfirm });
            this.showConfirmPanel();
            return true;
        }
        // $("#modalConfirm").modal("close");

        return false;
    }

    salvaCategoria() {

        console.log(this.componentName + 'salvaCategoria');

        if (!this.validateForm()) {
            console.log('validateForm return false');
            return null;
        }
        this.props.salvaCategoria().then(
            resolve => {
                this.props.history.push({ pathname: '/categorie/details' })
            }
        )

        console.log("\tloginOnClick - end");
    }

    inputChangeHandler(e, index) {
        if (e !== null && e !== undefined) {
            let value = e.target.value;
            let id = e.target.id;
            console.log(this.componentName + 'inputChangeHandler' + id);
            if (this.state.validation.has(id)) {
                this.state.validation.delete(id);
            }
            if (value === "[object Object]") {
                value = ""
            }

            let type = e.target.type;
            if (type === "number" && value === "") {
                value = null;
            }

            this.props.handleChange(id, value);
        }
    }

    render() {
        console.log(this.componentName + 'render');
        return (
            <div>
                <agui.aCardV4 className="mt-3 mb-3 inner-card">
                    <agui.aCardV4Header>
                        {this.props.categoriaProdotto && this.props.categoriaProdotto.id ?
                            <div style={{ fontSize: "x-large", fontWeight: "bold" }}>
                                {i18n('ARM_CORE_PRODUCT.CATEGORIA.MODIFICA_CATEGORIA_CON_ID', 'Modifica Categoria con id ')} {this.props.categoriaProdotto.id}
                            </div>
                            :
                            <div style={{ fontSize: "x-large", fontWeight: "bold" }}>
                                {i18n('ARM_CORE_PRODUCT.CATEGORIA.CREAZIONE_NUOVA_CATEGORIA', 'Creazione Nuova Categoria')}
                            </div>
                        }
                    </agui.aCardV4Header>
                    <agui.aCardV4Body>
                        <div>
                            <div className="row mt-4">

                                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                    <agui.ATextInputV4 id="nome" type="text"
                                        value={this.props.categoriaProdotto.nome}
                                        placeholder={i18n('ARM_CORE_PRODUCT.SHARED.INSERIRE_NOME', 'inserire nome')}
                                        required
                                        label={i18n('ARM_CORE_PRODUCT.MANAGE.NOME', 'Nome')}
                                        validation={this.state.validation}
                                        onChange={this.inputChangeHandler} />
                                </div>
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                    <agui.ASelectV4
                                        id="idFamigliaProdotto"
                                        required={true}
                                        validation={this.state.validation}
                                        onChange={this.inputChangeHandler}
                                        value={this.props.categoriaProdotto.idFamigliaProdotto}
                                        label={i18n('ARM_CORE_PRODUCT.SHARED.FAMIGLIA_PRODOTTO', 'Famiglia Prodotto')}
                                        items={this.props.famiglieProdotto}
                                        valueKey="id"
                                        labelKey="nome"
                                    />
                                </div>

                            </div>
                            <div className="row mt-4">
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                    <agui.ATextInputV4 id="descrizione" type="text"
                                        value={this.props.categoriaProdotto.descrizione}
                                        maxlength={255}
                                        validation={this.state.validation}
                                        label={i18n('ARM_CORE_PRODUCT.SHARED.DESCRIZIONE', 'Descrizione')}
                                        onChange={this.inputChangeHandler} />
                                </div>
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                    <agui.ATextInputV4 id="ordVis" type="number"
                                        min="0" step="1"
                                        info={i18n('ARM_CORE_PRODUCT.SHARED.NUMERO_INTERO', 'Solo numero intero')}
                                        value={this.props.categoriaProdotto ? this.props.categoriaProdotto.ordVis : null}
                                        label={i18n('ARM_CORE_PRODUCT.SHARED.ORDINE', 'Ordine')}
                                        onChange={this.inputChangeHandler} />

                                </div>
                            </div>
                            <div className="row mt-4">
                                {/* <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                    <agui.ATextInputV4 id="sigla" type="text"
                                        value={this.props.categoriaProdotto.sigla}
                                        placeholder={i18n('ARM_CORE_PRODUCT.SHARED.INSERIRE_SIGLA', 'inserire sigla')}
                                        onChange={this.inputChangeHandler} />
                                </div> */}
                            </div>
                        </div>
                        <br></br>

                    </agui.aCardV4Body>
                    <agui.aCardFooter>
                        <div>
                            <agui.aButton bs="primary" className="mr-2" icon="fas fa-save" onClick={this.validateForm}>{i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}</agui.aButton>
                            <agui.aButton bs="secondary" className="float-right mr-2" onClick={this.annullaButton}>{i18n('ARM_CORE_PRODUCT.SHARED.ANNULLA', 'Annulla')}</agui.aButton>
                        </div>
                    </agui.aCardFooter>
                </agui.aCardV4 >
                <ConfirmModalSaveV4
                    testoTitle={i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}
                    testoBody={this.props.testoBody !== undefined && this.props.testoBody !== null ? this.props.testoBody : i18n('ARM_CORE_PRODUCT.CONFERMI_DI.VOLER.SALV', 'Confermi di voler salvare?')}
                    testoButtonConfirm={i18n('ARM_CORE_PRODUCT.SALVA', 'Salva')}
                    testoButtonCancel={i18n('ARM_CORE_PRODUCT.SHARED.ANNULLA', 'Annulla')}
                    show={this.props.showConfirm}
                    saveOnClick={this.salvaCategoria}
                    onClose={this.showConfirmPanel} />

            </div >

        );
    }
};
function mapStateToProps(state) {
    return {
        categoriaProdotto: state.categorieProdotto.categoriaProdotto,
        showConfirm: state.app.showPopUp,
        famiglieProdotto: state.famiglieProdotto.listFamiglieProdotto,
    }
}

function mapDispatchToProps(dispatch) {
    return {

        salvaCategoria() {
            return dispatch(CategorieActions.salvaCategoria());
        },
        handleChange(index, e) {
            return dispatch(CategorieActions.handleChangeCategoria(index, e))
        },
        clearAll() {
            return dispatch(CategorieActions.clearAll());
        },
        showPopUP(isShow) {
            return dispatch(AppActions.showPopUp(isShow))
        },
        getListFamiglie() {
            return dispatch(FamiglieProdottoActions.getListFamiglie());
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateCategoria);
